import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';
import dayjs from 'dayjs';

@Component({
    selector: 'app-range-picker',
    templateUrl: './range-picker.component.html',
    styleUrls: ['./range-picker.component.less'],
})
export class RangePickerComponent implements OnInit, OnChanges {
    @Input() range: Date[] = [];
    @Input() nzAllowClear = true;
    @Input() minTime?: string;
    @Input() maxTime?: string;
    @Input() hasRealTimeRefresh = false;

    @Output() rangeChange = new EventEmitter();
    @Output() refresh = new EventEmitter();

    startTime?: Date;
    endTime?: Date;

    constructor() {
    }

    disabledDate = (current: Date): boolean => {
        let disabledValue = false;
        if (this.minTime) {
            disabledValue = differenceInCalendarDays(current, new Date(this.minTime)) < 0;
        }

        if (!disabledValue && this.maxTime) {
            disabledValue = differenceInCalendarDays(current, new Date(this.maxTime)) > 0;
        }
        return disabledValue;
    };

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.range.length > 0) {
            this.startTime = this.range[0];
            this.endTime = this.range[1];
        }
    }

    changeDate(): void {
        const range = [this.startTime, this.endTime];
        if ((this.startTime && this.endTime && !dayjs(this.startTime).isAfter(this.endTime)) || this.hasRealTimeRefresh) {
            this.rangeChange.emit(range);
            this.refresh.emit();
        }
    }
}
